import { useTranslation } from 'react-i18next';
import { ReassignContextDialog } from '@/components/processes/ReassignContextDialog';
import type { ProcessStepAssignment } from '@bliks-io/contracts';
import type { SuccessorUpdateData } from '@/pages/processes/recording/types';
import { toReassignPayload, type ReassignPayload } from '@/lib/successorEntityMapping';
import { isStartAnchoredSource } from '@/lib/assignment-source';
import { getProcessId } from '../utils/assignmentHelpers';

interface ReassignStepContentProps {
  open: boolean;
  assignment: ProcessStepAssignment;
  isSubmitting: boolean;
  onReviewReturn: () => void;
  onSubmitReassign: (params: ReassignPayload) => void;
}

export function ReassignStepContent({
  open,
  assignment,
  isSubmitting,
  onReviewReturn,
  onSubmitReassign
}: ReassignStepContentProps) {
  const { t } = useTranslation();

  const reassignProcessId = getProcessId(assignment.process);

  const handleReassignSave = (data: SuccessorUpdateData) => {
    const payload = toReassignPayload(data);
    if (payload) onSubmitReassign(payload);
  };

  // Closing the dialog (cancel / esc / outside-click) returns to the review
  // step rather than closing the whole flow, mirroring the prior "Back" button.
  return (
    <ReassignContextDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onReviewReturn();
      }}
      onSubmit={handleReassignSave}
      title={t('reassignContext.title')}
      description={t('reassignContext.descriptionRecording')}
      processId={reassignProcessId}
      recordingId={assignment.processStepRecording}
      hideExternalContact={isStartAnchoredSource(assignment.sourceProcessStep)}
      isSubmitting={isSubmitting}
    />
  );
}
